import Header from "@/components/Header";
import Footer from "@/components/Footer";
import Seo from "@/components/Seo";

export default function LegalPage() {
  return (
    <div className="min-h-screen flex flex-col page-enter">
      <Seo
        title="Mentions légales"
        description="Mentions légales du site Fiable ou Pas : éditeur, hébergement, propriété intellectuelle, responsabilité, droit applicable."
        path="/mentions-legales"
      />
      <Header />
      <main className="flex-1 py-12 bg-[#F9FAFB]">
        <div className="container-app max-w-3xl">
          <div className="card-base p-8 sm:p-10">
            <h1 className="text-3xl font-extrabold font-heading text-slate-900 mb-8">Mentions légales</h1>

            <div className="prose prose-slate max-w-none space-y-6 text-sm text-slate-600 leading-relaxed">
              <section>
                <h2 className="text-lg font-bold text-slate-800 mb-3">Éditeur du site</h2>
                <p>
                  David Ramaugé<br />
                  Email : <a href="mailto:hello@fiableoupas.com" className="text-[#1E3A8A] underline">hello@fiableoupas.com</a>
                </p>
                <p className="mt-4">
                  Le site <strong>fiableoupas.com</strong> est édité en tant qu'outil informatif d'aide à la décision
                  destiné aux consommateurs français.
                </p>
              </section>

              <section>
                <h2 className="text-lg font-bold text-slate-800 mb-3">Hébergement</h2>
                <p>
                  <strong>Frontend :</strong> Vercel Inc. — 340 Pine Street, Suite 1500, San Francisco, CA 94104, USA<br />
                  <strong>Backend :</strong> Fly.io — 2261 Market Street #4990, San Francisco, CA 94114, USA
                </p>
                <p className="mt-4">
                  Ce site est hébergé sur des serveurs cloud sécurisés. Les données sont traitées conformément au RGPD.
                </p>
              </section>

              <section>
                <h2 className="text-lg font-bold text-slate-800 mb-3">Propriété intellectuelle</h2>
                <p>
                  L'ensemble du contenu de ce site (textes, logos, interface) est la propriété exclusive de Fiable ou Pas.
                  Toute reproduction, même partielle, est interdite sans autorisation préalable écrite.
                </p>
              </section>

              <section>
                <h2 className="text-lg font-bold text-slate-800 mb-3">Responsabilité</h2>
                <p>
                  Fiable ou Pas est un outil d'aide à la décision informatif. Les scores attribués reflètent une analyse automatisée de signaux publiquement disponibles à un instant donné. Ils ne constituent pas une accusation et peuvent évoluer. Tout propriétaire de site peut nous contacter pour signaler une erreur d'analyse.
                </p>
                <p className="mt-2">
                  L'éditeur ne peut être tenu responsable d'un préjudice quelconque lié à l'utilisation des informations
                  fournies par cet outil. Les données analysées peuvent être incomplètes ou imprécises.
                </p>
                <p className="mt-2">
                  Fiable ou Pas n'est pas une autorité légale ou officielle. En cas de fraude avérée, contactez les
                  autorités compétentes (police, gendarmerie, SignalConso).
                </p>
              </section>

              <section>
                <h2 className="text-lg font-bold text-slate-800 mb-3">Liens affiliés</h2>
                <p>
                  Certains articles de ce site peuvent contenir des liens affiliés. Si vous
                  cliquez sur ces liens et effectuez un achat, Fiable ou Pas peut percevoir
                  une commission, sans coût supplémentaire pour vous. Ces liens sont clairement identifiés et n’influencent ni notre méthodologie d’analyse, ni les scores attribués, ni nos recommandations éditoriales.
                </p>
              </section>

              <section>
                <h2 className="text-lg font-bold text-slate-800 mb-3">Données personnelles</h2>
                <p>
                  Fiable ou Pas traite les données conformément au Règlement Général sur la Protection des Données (RGPD).
                  Pour plus d'informations, consultez notre{" "}
                  <a href="/politique-de-confidentialite" className="text-[#1E3A8A] underline">
                    Politique de confidentialité
                  </a>.
                </p>
              </section>

              <section>
                <h2 className="text-lg font-bold text-slate-800 mb-3">Droit applicable</h2>
                <p>
                  Le présent site est soumis au droit français. Tout litige relatif à son utilisation est de la compétence
                  exclusive des tribunaux français.
                </p>
              </section>

              <p className="text-xs text-slate-400 pt-4 border-t border-slate-100">
                Dernière mise à jour : {new Date().toLocaleDateString("fr-FR", { month: "long", year: "numeric" })}
              </p>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
